import { render, staticRenderFns } from "./ImpersonationStatus.vue?vue&type=template&id=591bcf65&scoped=true&"
import script from "./ImpersonationStatus.vue?vue&type=script&lang=ts&"
export * from "./ImpersonationStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ImpersonationStatus.vue?vue&type=style&index=0&id=591bcf65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591bcf65",
  null
  
)

export default component.exports